import { z } from 'zod'

export const SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS = {
  name: 256,
  cat: 4,
  functiontypes: 50,
  missiontime: 32,
  channeltype: 9,
} as const

export type SistemaComponentFormData = {
  name: string
  cat: string
  functiontypes: string
  missiontime: string
}

export type SistemaChannelFormData = {
  name: string
  channeltype: string
}

export type SistemaNodeFormData = {
  name: string
}

export const defaultSistemaComponentFormData: SistemaComponentFormData = {
  name: '',
  cat: '',
  functiontypes: '',
  missiontime: '',
}

export const defaultSistemaChannelFormData: SistemaChannelFormData = {
  name: '',
  channeltype: '',
}

export const defaultSistemaNodeFormData: SistemaNodeFormData = {
  name: '',
}

const optionalTrimmedString = (maxLength: number) =>
  z.string().trim().max(maxLength)

export const sistemaComponentFormSchema = z.object({
  name: z.string().trim().min(1).max(SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.name),
  cat: optionalTrimmedString(SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.cat),
  functiontypes: optionalTrimmedString(
    SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.functiontypes
  ),
  missiontime: optionalTrimmedString(
    SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.missiontime
  ),
})

export const sistemaChannelFormSchema = z.object({
  name: z.string().trim().min(1).max(SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.name),
  channeltype: optionalTrimmedString(
    SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.channeltype
  ),
})

export const sistemaNodeFormSchema = z.object({
  name: z.string().trim().min(1).max(SISTEMA_ARCHITECTURE_FIELD_MAX_LENGTHS.name),
})

export function validateSistemaComponentForm(data: SistemaComponentFormData) {
  return sistemaComponentFormSchema.safeParse(data)
}

export function validateSistemaChannelForm(data: SistemaChannelFormData) {
  return sistemaChannelFormSchema.safeParse(data)
}

export function validateSistemaNodeForm(data: SistemaNodeFormData) {
  return sistemaNodeFormSchema.safeParse(data)
}

function trimOrNull(value: string) {
  const trimmed = value.trim()
  if (trimmed.length === 0) {
    return null
  }
  return trimmed
}

export function toSistemaComponentPayload(data: SistemaComponentFormData) {
  return {
    name: data.name.trim(),
    cat: trimOrNull(data.cat),
    functiontypes: trimOrNull(data.functiontypes),
    missiontime: trimOrNull(data.missiontime),
  }
}

export function toSistemaChannelPayload(data: SistemaChannelFormData) {
  return {
    name: data.name.trim(),
    channeltype: trimOrNull(data.channeltype),
  }
}

export function toSistemaNodePayload(data: SistemaNodeFormData) {
  return {
    name: data.name.trim(),
  }
}
